import { LoggerProvider, BatchLogRecordProcessor } from '@opentelemetry/sdk-logs'
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http'
import { resourceFromAttributes } from '@opentelemetry/resources'
import type { OtelConfig } from './loggerTypes'

let isInitialized = false
let provider: LoggerProvider | null = null

export function initOtel(config: OtelConfig) {
  if (isInitialized || !config.enabled) return
  isInitialized = true

  const resource = resourceFromAttributes({
    ['service.name']: config.serviceName,
    ['service.version']: config.serviceVersion,
    ['deployment.environment']: config.environment,
  })

  const exporter = new OTLPLogExporter({
    url: config.collectorUrl,
    headers: config.headers,
  })

  const processor = new BatchLogRecordProcessor(exporter, {
    scheduledDelayMillis: config.batch?.scheduledDelayMillis || 5000,
    maxExportBatchSize: config.batch?.maxExportBatchSize || 512,
    maxQueueSize: config.batch?.maxQueueSize || 2048,
    exportTimeoutMillis: config.batch?.exportTimeoutMillis || 30000,
  })

  provider = new LoggerProvider({ 
    resource,
    processors: [processor]
  })
}

export function getOtelLogger() {
  if (!isInitialized || !provider) return null
  return provider.getLogger('conex360-logger')
}

export async function forceFlushOtel() {
  if (provider) {
    try {
      await provider.forceFlush()
    } catch {
      // Failsafe — never let a flush error crash the app
    }
  }
}

export async function shutdownOtel() {
  if (provider) {
    await provider.shutdown()
    provider = null
    isInitialized = false
  }
}
